function format(date,fmt){//日期格式化
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
        "y+":date.getFullYear(),
		"M+":date.getMonth()+1,
		"d+":date.getDate(),
		"H+":date.getHours(),
		"m+":date.getMinutes(),
		"s+":date.getSeconds(),
		"S":date.getMilliseconds(),
		"h+":(date.getHours()%12),
		"a":(date.getHours()/12)<=1?"AM":"PM"
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
        }
    }
    return fmt;
}
function padLeftZero(str) {
    return ('00' + str).substr(str.length);
}
export default {
    format
}